/* CCC Courier theme v1.3.3 — step-by-step booking form
   Sends the same line item properties, in the same order, as the old
   product-options app so orders keep flowing into the booking platform. */
(function () {
  'use strict';

  var CCC = window.CCC || {};

  /* The order the old app sent properties in. Keep this list in sync with the platform import. */
  var PROP_ORDER = [
    'Bike Brand', 'Bike Model', 'Bike Value', 'eBay Collection Code',
    'Collection Name', 'Collection Email', 'Collection Mobile Number', 'Collection Street Address',
    'Collection City', 'Collection County', 'Collection Postcode',
    'Delivery Name', 'Delivery Email', 'Delivery Mobile Number', 'Delivery Street Address',
    'Delivery City', 'Delivery County', 'Delivery Postcode'
  ];
  var STORE_KEY = 'ccc-booking-draft-v1';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  /* UK phone numbers. The field shows a fixed +44, so people type the rest.
     07700 900123, 7700 900123, +44 7700 900123 and 447700900123 all work. */
  function ukLocal(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.length === 12 && d.indexOf('44') === 0) d = d.slice(2);
    else if (d.length === 13 && d.indexOf('440') === 0) d = d.slice(3);
    if (d.charAt(0) === '0') d = d.slice(1);
    return d;
  }
  function ukValid(v) { return /^[1-9]\d{9}$/.test(ukLocal(v)); }
  function ukDisplay(v) { var d = ukLocal(v); return d.length === 10 ? d.slice(0, 4) + ' ' + d.slice(4) : String(v || '').trim(); }
  function ukE164(v) { return '+44' + ukLocal(v); }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return CCC.escapeHtml ? CCC.escapeHtml(s) : String(s); }
  function money(c) { return CCC.formatMoney ? CCC.formatMoney(c) : '£' + (c / 100); }
  function icon(name) {
    var paths = {
      alert: '<path d="M12 4.2l8.8 15.3H3.2z"/><path d="M12 10v4.2M12 16.8v.4"/>',
      check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
      info: '<circle cx="12" cy="12" r="8.5"/><path d="M12 11v5.2M12 7.8v.4"/>'
    };
    return '<svg class="icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (paths[name] || '') + '</svg>';
  }

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';

    var form = $('[data-booking-form]', root);
    var service = root.dataset.service || 'ew';
    var otherUrl = root.dataset.otherUrl || '';
    var skipCart = root.dataset.skipCart === 'true';
    var fromPrice = parseInt(root.dataset.fromPrice, 10) || 0;
    var allSteps = $$('[data-step]', root);
    var steps = allSteps.filter(function (s) { return !s.hasAttribute('data-skip'); });
    var nav = $('[data-step-nav]', root);
    var backBtn = $('[data-back]', root);
    var nextBtn = $('[data-next]', root);
    var bar = $('[data-booking-bar]', root);
    var barNext = $('[data-bar-next]', root);
    var barLabel = $('[data-bar-label]', root);
    var barTotal = $('[data-bar-total]', root);
    var progressItems = $$('[data-progress-step]', root);
    var progressText = $('[data-progress-text]', root);
    var progressFill = $('[data-progress-fill]', root);
    var addon = $('[data-addon]', root);
    var payBtn = $('[data-pay]', root);
    var anotherBtn = $('[data-add-another]', root);
    var submitError = $('[data-submit-error]', root);
    var toast = $('[data-toast]', root);
    var ebayToggle = $('[data-ebay-toggle]', root);
    var ebayField = $('[data-ebay-field]', root);
    var sameContact = $('[data-same-contact]', root);
    var current = 0;
    var busy = false;

    function prop(name) { return form.querySelector('[data-prop="' + name + '"]'); }
    function val(name) { var el = prop(name); return el ? el.value.trim() : ''; }

    function selectedVariant() {
      var single = form.querySelector('[data-single-variant]');
      if (single) return single;
      return form.querySelector('input[name="id"]:checked');
    }

    /* ---------- Draft storage (per browser tab) ---------- */
    function saveDraft() {
      try {
        var data = { props: {}, bike: '', ebay: ebayToggle ? ebayToggle.checked : false };
        PROP_ORDER.forEach(function (k) { var el = prop(k); if (el) data.props[k] = el.value; });
        var v = selectedVariant();
        if (v && !v.hasAttribute('data-single-variant')) data.bike = v.dataset.title || '';
        sessionStorage.setItem(STORE_KEY, JSON.stringify(data));
      } catch (e) { /* storage unavailable */ }
    }
    function loadDraft() {
      try { return JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; }
    }
    function clearDraft() {
      try { sessionStorage.removeItem(STORE_KEY); } catch (e) { /* ignore */ }
    }

    function selectBikeByTitle(title) {
      if (!title) return false;
      var match = $$('input[name="id"]', form).filter(function (r) {
        return (r.dataset.title || '').toLowerCase() === String(title).toLowerCase();
      })[0];
      if (match && !match.disabled) { match.checked = true; return true; }
      return false;
    }

    /* ---------- Prefill from URL and draft ---------- */
    var params = new URLSearchParams(window.location.search);
    var draft = loadDraft();
    if (draft && draft.props) {
      Object.keys(draft.props).forEach(function (k) {
        var el = prop(k);
        if (el && !el.value) el.value = draft.props[k] || '';
      });
      if (!params.get('variant') && !selectedVariant()) selectBikeByTitle(draft.bike);
      if (draft.ebay && ebayToggle) ebayToggle.checked = true;
    }
    if (params.get('bike')) selectBikeByTitle(params.get('bike'));
    if (params.get('variant') && !selectedVariant()) {
      var byId = form.querySelector('input[name="id"][value="' + params.get('variant').replace(/[^0-9]/g, '') + '"]');
      if (byId && !byId.disabled) byId.checked = true;
    }
    if (params.get('from') && prop('Collection Postcode')) prop('Collection Postcode').value = CCC.postcode.format(params.get('from'));
    if (params.get('to') && prop('Delivery Postcode')) prop('Delivery Postcode').value = CCC.postcode.format(params.get('to'));
    if (ebayToggle && ebayField) {
      if (val('eBay Collection Code')) ebayToggle.checked = true;
      ebayField.hidden = !ebayToggle.checked;
    }

    /* ---------- Validation ---------- */
    function fieldOf(el) { return el.closest('[data-field]'); }
    function setError(el, message) {
      var f = fieldOf(el);
      if (!f) return;
      f.classList.add('is-invalid');
      el.setAttribute('aria-invalid', 'true');
      if (message) {
        var t = f.querySelector('[data-error-text]');
        if (t) t.textContent = message;
      }
    }
    function clearError(el) {
      var f = fieldOf(el);
      if (!f) return;
      f.classList.remove('is-invalid');
      el.removeAttribute('aria-invalid');
    }

    function checkInput(el) {
      var v = el.value.trim();
      if (el.required && !v) return false;
      if (!v) return true;
      if (el.type === 'email') return EMAIL_RE.test(v);
      if (el.hasAttribute('data-phone')) return ukValid(v);
      if (el.type === 'tel') {
        var digits = v.replace(/[^0-9]/g, '');
        return digits.length >= 10 && digits.length <= 15;
      }
      if (el.hasAttribute('data-postcode')) return CCC.postcode.isValid(v);
      if (el.dataset.prop === 'Bike Value') {
        var n = parseFloat(v.replace(/[^0-9.]/g, ''));
        return !isNaN(n) && n > 0;
      }
      return true;
    }

    function regionNotice(step) {
      var box = step.querySelector('[data-region-notice]');
      if (!box) return true;
      var stop = step.dataset.stop;
      var from = val('Collection Postcode');
      var to = stop === 'delivery' ? val('Delivery Postcode') : '';
      var result = CCC.checkRoute(from, to, service);
      if (result.ok || result.kind === 'invalid') { box.hidden = true; return true; }

      var html = '';
      var wa = (CCC.settings && CCC.settings.whatsapp) ? ' <a href="' + CCC.settings.whatsapp + '" target="_blank" rel="noopener">WhatsApp us</a>' : '';
      if (result.kind === 'ni') {
        html = 'This journey goes to or from Northern Ireland, which has its own rates.' +
          (otherUrl ? ' <a href="' + otherUrl + '" data-carry>Switch to our Northern Ireland service</a>. Your details come with you.' : wa);
      } else if (result.kind === 'ew') {
        html = 'Neither address is in Northern Ireland.' +
          (otherUrl ? ' <a href="' + otherUrl + '" data-carry>Book with our England and Wales service</a> instead. Your details come with you.' : '');
      } else {
        html = esc(CCC.routeMessage(result.kind)) + wa;
      }
      box.innerHTML = icon('alert') + '<span>' + html + '</span>';
      box.hidden = false;
      wireCarry(box);
      return false;
    }

    function validateStep(step, quiet) {
      var ok = true;
      var firstBad = null;

      if (step.dataset.step === '1' && !step.hasAttribute('data-skip')) {
        var groups = step.querySelector('[data-bike-field]');
        if (!selectedVariant()) {
          ok = false;
          if (!quiet && groups) { groups.classList.add('is-invalid'); firstBad = firstBad || step.querySelector('input[name="id"]:not(:disabled)'); }
        } else if (groups) {
          groups.classList.remove('is-invalid');
        }
      }

      $$('[data-prop]', step).forEach(function (el) {
        var hiddenParent = el.closest('[hidden]');
        if (hiddenParent && hiddenParent !== step && step.contains(hiddenParent)) return;
        if (!checkInput(el)) {
          ok = false;
          if (!quiet) { setError(el); firstBad = firstBad || el; }
        } else if (!quiet) {
          clearError(el);
        }
      });

      if (ok && step.dataset.stop) {
        ok = regionNotice(step);
        if (!ok && !quiet) firstBad = firstBad || step.querySelector('[data-region-notice]');
      }

      if (!ok && !quiet && firstBad) {
        if (firstBad.hasAttribute('data-region-notice')) {
          firstBad.setAttribute('tabindex', '-1');
          firstBad.focus({ preventScroll: true });
          firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          firstBad.focus();
        }
      }
      return ok;
    }

    /* ---------- Summary ---------- */
    function totalCents() {
      var v = selectedVariant();
      var t = v ? parseInt(v.dataset.price, 10) || 0 : 0;
      if (addon && addon.checked) t += parseInt(addon.dataset.price, 10) || 0;
      return t;
    }

    function setSum(key, html, empty) {
      var el = root.querySelector('[data-sum="' + key + '"]');
      if (!el) return;
      el.innerHTML = html || '<span class="bsum__empty">' + empty + '</span>';
    }

    function stopSummary(prefix) {
      var pc = val(prefix + ' Postcode');
      var city = val(prefix + ' City');
      if (!pc && !city) return '';
      return '<span class="bsum__postcode">' + esc(pc ? CCC.postcode.format(pc) : '') + '</span>' +
        (city ? '<br><span class="muted">' + esc(city) + '</span>' : '');
    }

    function updateSummary() {
      var v = selectedVariant();
      var bikeText = '';
      if (v) {
        bikeText = esc(v.dataset.label || '');
        var bm = [val('Bike Brand'), val('Bike Model')].filter(Boolean).join(' ');
        if (bm) bikeText += '<br><span class="muted">' + esc(bm) + '</span>';
      }
      setSum('bike', bikeText, 'Not chosen yet');
      setSum('from', stopSummary('Collection'), 'Add in step 3');
      setSum('to', stopSummary('Delivery'), 'Add in step 4');

      var addonRow = root.querySelector('[data-sum-addon]');
      if (addonRow) {
        addonRow.hidden = !(addon && addon.checked);
        if (addon && addon.checked) setSum('addon', money(parseInt(addon.dataset.price, 10) || 0));
      }

      var total = totalCents();
      var totalText = v ? money(total) : 'From ' + money(fromPrice);
      setSum('total', esc(totalText));
      if (barTotal) barTotal.textContent = totalText;
      if (barLabel) {
        var onLast = steps.length && current === steps.length - 1;
        barLabel.textContent = onLast ? 'Total' : (v ? (v.dataset.label || '') : 'Choose a bike type');
      }
    }

    /* ---------- Review sheet ---------- */
    function reviewBlock(title, stepNo, main, sub) {
      return '<div class="review-block">' +
        '<div class="review-block__head"><h3 class="review-block__title">' + esc(title) + '</h3>' +
        '<button type="button" class="review-block__edit" data-edit="' + stepNo + '">Change<span class="visually-hidden"> ' + esc(title.toLowerCase()) + '</span></button></div>' +
        '<p class="review-block__main">' + main + '</p>' +
        (sub ? '<p class="review-block__sub">' + sub + '</p>' : '') +
        '</div>';
    }

    function renderReview() {
      var sheet = root.querySelector('[data-review]');
      if (!sheet) return;
      var v = selectedVariant();
      var html = '';
      var hasBikeStep = steps.indexOf(allSteps[0]) > -1;
      if (hasBikeStep && v) {
        html += reviewBlock('Bike type', 1, esc(v.dataset.label || '') + ' <span class="muted">' + money(parseInt(v.dataset.price, 10) || 0) + '</span>', '');
      }
      var detail = [val('Bike Brand'), val('Bike Model')].filter(Boolean).join(' ');
      var value = val('Bike Value').replace(/[^0-9.]/g, '');
      var sub = value ? 'Insured value ' + esc(money(Math.round(parseFloat(value) * 100))) : '';
      if (ebayToggle && ebayToggle.checked && val('eBay Collection Code')) sub += (sub ? '<br>' : '') + 'eBay collection code ' + esc(val('eBay Collection Code'));
      html += reviewBlock('About the bike', 2, esc(detail), sub);

      ['Collection', 'Delivery'].forEach(function (p, i) {
        var main = esc(val(p + ' Name'));
        var lines = [
          [val(p + ' Street Address'), val(p + ' City'), val(p + ' County'), CCC.postcode.format(val(p + ' Postcode'))].filter(Boolean).map(esc).join(', '),
          [val(p + ' Mobile Number') ? '+44 ' + ukDisplay(val(p + ' Mobile Number')) : '', val(p + ' Email')].filter(Boolean).map(esc).join(', ')
        ].filter(Boolean).join('<br>');
        html += reviewBlock(p === 'Collection' ? 'Collect from' : 'Deliver to', i + 3, main, lines);
      });
      sheet.innerHTML = html;
      $$('[data-edit]', sheet).forEach(function (b) {
        b.addEventListener('click', function () {
          var target = allSteps[parseInt(b.dataset.edit, 10) - 1];
          var idx = steps.indexOf(target);
          if (idx > -1) goTo(idx);
        });
      });
    }

    /* ---------- Navigation ---------- */
    function updateProgress() {
      var logical = parseInt(steps[current].dataset.step, 10);
      progressItems.forEach(function (li) {
        var n = parseInt(li.dataset.progressStep, 10);
        var stepEl = allSteps[n - 1];
        var idx = steps.indexOf(stepEl);
        li.classList.toggle('is-current', n === logical);
        li.classList.toggle('is-done', idx > -1 && idx < current);
        var btn = li.querySelector('button');
        if (btn) {
          btn.disabled = !(idx > -1 && idx < current);
          if (n === logical) btn.setAttribute('aria-current', 'step'); else btn.removeAttribute('aria-current');
        }
      });
      if (progressText) {
        var label = progressItems[logical - 1] ? progressItems[logical - 1].textContent.trim() : '';
        progressText.textContent = 'Step ' + (current + 1) + ' of ' + steps.length + (label ? ': ' + label : '');
      }
      var pct = Math.round(((current + 1) / steps.length) * 100);
      if (progressFill) progressFill.style.width = pct + '%';
      var miniVan = root.querySelector('[data-progress-mini-van]');
      if (miniVan) miniVan.style.left = pct + '%';
      var van = root.querySelector('[data-progress-van]');
      var list = root.querySelector('[data-progress]');
      var cur = list && list.querySelector('.progress-step.is-current .progress-step__dot');
      if (van && cur && list.offsetWidth) {
        var lr = list.getBoundingClientRect(), dr = cur.getBoundingClientRect();
        var prevLeft = parseFloat(van.style.left) || 0;
        var nextLeft = dr.left - lr.left + dr.width / 2;
        van.classList.toggle('is-reversing', nextLeft < prevLeft);
        van.classList.add('is-moving');
        van.style.left = nextLeft + 'px';
        clearTimeout(updateProgress.t);
        updateProgress.t = setTimeout(function () { van.classList.remove('is-moving'); }, 750);
      }
    }

    function goTo(index, opts) {
      opts = opts || {};
      current = Math.max(0, Math.min(index, steps.length - 1));
      allSteps.forEach(function (s) { s.hidden = s !== steps[current]; });
      var isLast = current === steps.length - 1;
      if (nav) {
        nav.classList.toggle('is-first', current === 0);
        nav.classList.toggle('is-last', isLast);
      }
      if (barNext) barNext.textContent = isLast ? (payBtn ? payBtn.textContent.trim() : 'Pay') : 'Continue';
      if (isLast) renderReview();
      updateProgress();
      updateSummary();
      if (!opts.silent) {
        var title = steps[current].querySelector('.bstep__title');
        var top = root.getBoundingClientRect().top + window.scrollY - 90;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
        if (title) title.focus({ preventScroll: true });
        CCC.track && CCC.track('ccc:booking_step', { step: steps[current].dataset.step, service: service });
      }
    }

    function next() {
      if (!validateStep(steps[current])) return;
      saveDraft();
      if (current < steps.length - 1) goTo(current + 1);
    }
    function back() { if (current > 0) goTo(current - 1); }

    /* ---------- Add to basket ---------- */
    function collectProps() {
      var props = {};
      PROP_ORDER.forEach(function (k) {
        var el = prop(k);
        if (!el) return;
        if (k === 'eBay Collection Code' && ebayToggle && !ebayToggle.checked) return;
        var v = el.value.trim();
        if (!v) return;
        if (/Postcode$/.test(k)) v = CCC.postcode.format(v);
        if (k === 'Bike Value') v = v.replace(/[^0-9.]/g, '');
        if (el.hasAttribute('data-phone')) v = ukE164(v);
        props[k] = v;
      });
      return props;
    }

    function showToast(message) {
      if (!toast) return;
      toast.innerHTML = icon('check') + '<span>' + esc(message) + '</span>';
      toast.hidden = false;
      clearTimeout(showToast.t);
      showToast.t = setTimeout(function () { toast.hidden = true; }, 5000);
    }

    function addToCart(mode) {
      if (busy) return;
      for (var i = 0; i < steps.length - 1; i++) {
        if (!validateStep(steps[i], true)) { goTo(i); validateStep(steps[i]); return; }
      }
      var v = selectedVariant();
      if (!v) { goTo(0); return; }

      var props = collectProps();
      var items = [{ id: parseInt(v.value, 10), quantity: 1, properties: props }];
      if (addon && addon.checked) {
        var forBike = [props['Bike Brand'], props['Bike Model']].filter(Boolean).join(' ');
        items.push({
          id: parseInt(addon.value, 10),
          quantity: 1,
          properties: { 'For bike': forBike + ' (' + (props['Collection Postcode'] || '') + ' to ' + (props['Delivery Postcode'] || '') + ')' }
        });
      }

      busy = true;
      var btn = mode === 'another' ? anotherBtn : payBtn;
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
      if (submitError) submitError.hidden = true;

      fetch((CCC.routes && CCC.routes.cartAdd ? CCC.routes.cartAdd : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Something went wrong.');
            return data;
          });
        })
        .then(function () {
          CCC.track && CCC.track('ccc:booking_added', { service: service, bike: v.dataset.title, addon: !!(addon && addon.checked) });
          if (mode === 'another') {
            resetForAnother();
            CCC.updateCartCount && CCC.updateCartCount();
            showToast('Added to your basket. Addresses are kept for the next bike.');
            busy = false;
            if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
            return;
          }
          clearDraft();
          window.location.href = skipCart ? '/checkout' : ((CCC.routes && CCC.routes.cart) || '/cart');
        })
        .catch(function (err) {
          busy = false;
          if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
          if (submitError) {
            submitError.innerHTML = icon('alert') + '<span>' + esc(err.message || 'Something went wrong.') + ' Try again, or message us and we’ll book it for you.</span>';
            submitError.hidden = false;
            submitError.setAttribute('tabindex', '-1');
            submitError.focus();
          }
        });
    }

    function resetForAnother() {
      ['Bike Brand', 'Bike Model', 'Bike Value', 'eBay Collection Code'].forEach(function (k) {
        var el = prop(k); if (el) el.value = '';
      });
      $$('input[name="id"]', form).forEach(function (r) { r.checked = false; });
      if (ebayToggle) { ebayToggle.checked = false; if (ebayField) ebayField.hidden = true; }
      if (addon) addon.checked = addon.defaultChecked;
      saveDraft();
      goTo(0);
    }

    /* ---------- Carry details when switching service ---------- */
    function wireCarry(scope) {
      $$('[data-carry], [data-switch-service]', scope || root).forEach(function (a) {
        if (a.dataset.wired) return;
        a.dataset.wired = 'true';
        a.addEventListener('click', function (e) {
          saveDraft();
          var v = selectedVariant();
          if (v && v.dataset.title && !v.hasAttribute('data-single-variant')) {
            e.preventDefault();
            var url = a.getAttribute('href');
            window.location.href = url + (url.indexOf('?') > -1 ? '&' : '?') + 'bike=' + encodeURIComponent(v.dataset.title);
          }
        });
      });
    }

    /* ---------- Events ---------- */
    if (nextBtn) nextBtn.addEventListener('click', next);
    if (backBtn) backBtn.addEventListener('click', back);
    if (barNext) barNext.addEventListener('click', function () {
      if (current === steps.length - 1) addToCart('pay'); else next();
    });
    $$('[data-goto]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var target = allSteps[parseInt(b.dataset.goto, 10) - 1];
        var idx = steps.indexOf(target);
        if (idx > -1 && idx < current) goTo(idx);
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (current < steps.length - 1) { next(); return; }
      addToCart('pay');
    });
    if (anotherBtn) anotherBtn.addEventListener('click', function () { addToCart('another'); });

    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName === 'INPUT' && e.target.type !== 'checkbox' && e.target.type !== 'radio' && current < steps.length - 1) {
        e.preventDefault();
        next();
      }
    });

    form.addEventListener('change', function (e) {
      if (e.target.name === 'id') {
        var g = form.querySelector('[data-bike-field]');
        if (g) g.classList.remove('is-invalid');
      }
      if (e.target === addon) renderReview();
      updateSummary();
      saveDraft();
    });

    form.addEventListener('input', function (e) {
      var el = e.target;
      if (el.hasAttribute('data-prop') && fieldOf(el) && fieldOf(el).classList.contains('is-invalid') && checkInput(el)) clearError(el);
      updateSummary();
    });

    $$('[data-postcode]', form).forEach(function (el) {
      el.addEventListener('blur', function () {
        if (el.value.trim()) el.value = CCC.postcode.format(el.value);
        var step = el.closest('[data-step]');
        if (step && CCC.postcode.isValid(el.value)) regionNotice(step);
        updateSummary();
        saveDraft();
      });
    });

    $$('[data-prop]', form).forEach(function (el) {
      el.addEventListener('blur', function () {
        if (el.hasAttribute('data-phone') && ukValid(el.value)) el.value = ukDisplay(el.value);
        if (el.value.trim() && !checkInput(el)) setError(el);
      });
    });

    if (ebayToggle && ebayField) {
      ebayToggle.addEventListener('change', function () {
        ebayField.hidden = !ebayToggle.checked;
        if (ebayToggle.checked) { var i = ebayField.querySelector('input'); if (i) i.focus(); }
      });
    }

    if (sameContact) {
      sameContact.addEventListener('change', function () {
        if (!sameContact.checked) return;
        [['Collection Name', 'Delivery Name'], ['Collection Email', 'Delivery Email'], ['Collection Mobile Number', 'Delivery Mobile Number']].forEach(function (pair) {
          var a = prop(pair[0]); var b = prop(pair[1]);
          if (a && b) { b.value = a.value; clearError(b); }
        });
        saveDraft();
      });
    }

    /* Hide the mobile bar while the in-form buttons are on screen */
    if (bar && 'IntersectionObserver' in window) {
      var onScreen = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) onScreen.add(en.target); else onScreen.delete(en.target); });
        bar.classList.toggle('is-hidden', onScreen.size > 0);
      }, { rootMargin: '0px 0px -40px 0px' });
      if (nextBtn) io.observe(nextBtn);
      if (payBtn) io.observe(payBtn);
    }

    wireCarry(root);

    /* ---------- Start ---------- */
    var start = 0;
    if (selectedVariant() && steps[0] && steps[0].dataset.step === '1') {
      start = 1;
      if (params.get('step') === 'bike') start = 0;
    }
    goTo(start, { silent: true });
  }

  function boot() { document.querySelectorAll('[data-booking]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-booking]'); if (r) init(r); });
})();
